






















import Vue from 'vue'
import { sprintf } from 'sprintf-js'
import { getText } from '../js/lang'
import TicketPreview from './ticket-preview.vue'
import TweetButton from './tweet-button.vue'

interface Stamp {
  pos: [number, number]
  rot: number
}

interface Ticket {
  publish_id: string
  ticket_id: string
  name: string
  country_code?: string
  stamps: Stamp[]
}

export default Vue.extend({
  name: 'retrieve-view',
  components: { TicketPreview, TweetButton },
  props: {
    lang: {
      type: String,
      required: true
    },
    ticket: {
      type: Object as () => Ticket,
      required: true
    },
    query: {
      type: Object,
      default: () => ({})
    },
    debug: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    l(key: string, ...values: any[]): string {
      return sprintf(getText(this.lang, key), ...values)
    }
  }
})
